import { Notification } from '@modules/notifications/types';
import { useNotificationsStore } from './useNotificationsStore';

export const useAddNotification = (): ((notification: Notification) => void) =>
  useNotificationsStore((state) => state.addNotification);
export const useRemoveNotification = (): ((id: number) => void) =>
  useNotificationsStore((state) => state.removeNotification);
export const useGetNotifications = (): Notification[] => useNotificationsStore((state) => state.notifications);
